import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            companyId: '',
            filter: '',
            companyName: '',
            openAddOrder: false,
            managers: [],
            types: [],
        }
    },
    computed: {
        filteredUsers() {
            return this.managers.filter(item => {
                return item.firstName.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.lastName.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.username.toLowerCase().indexOf(this.filter.toLowerCase()) > -1

            })
        }
    },
    methods: {
        getManagers: getManagers,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        onClickUser: onClickUser,
        openAddUserModal: openAddUserModal,
        deleteCompanyStuff: deleteCompanyStuff,
        compareActive(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrders(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

    },
    created(){
        let _self = this;
        this.$topnavbar.$on('closeAddCompanyStuff', () => {
            _self.openAddOrder = false;
        });
        this.$topnavbar.$on('successAddCompanyStuff', () => {
            _self.openAddOrder = false;
            swal('Uspešno', 'Uspešno dodat menadžer', 'success')
            _self.getManagers();
        });

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.companyName = this.$route.query.name;
        this.companyId = this.$route.query.id;
        this.getManagers()
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
    }
}

function openAddUserModal() {
    this.openAddOrder = true;
}

function clickSearch() {
    // this.pagination.page = 1;
    // this.getDrivers()
}

function getManagers() {
    var _self = this;
    AdminApiService.getCompanyStuffs(_self.companyId)
        .then((response) => {
            _self.managers = response.data;
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getManagers();
    }
}



function onClickUser(user) {
    swal({
        title: ''+user.name + ' '+ user.surname,
        html : '<html><div class="foo">' +
            '<br><div><b>Korisničko ime:</b>&ensp;'+ user.username+'</div><br>'+
            '<div><b>Email:</b>&ensp;'+ user.email+'</div><br>'+
            '<div><b>Telefon:</b>&ensp;'+ user.phone+'</div><br>'+
            '<div><b>Preostalo treninga:</b>&ensp;'+ user.restOfTraining+'</div><br>'+

            '</div></html>',
        text: "",
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Zatvori',
        customClass: 'swal2-warning'
    }).then(function () {

    });
}


function deleteCompanyStuff(item) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete menadžera " + item.username + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteCompanyStuff(item.id, _self.companyId)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali menadžera', 'success')
                _self.getManagers();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}



// WEBPACK FOOTER //
// ./src/components/Company/Managers.js